//
//
//
//
//
//
//
//
//
//
//


const { windowWidth } = wx.getSystemInfoSync()
const RATIO = windowWidth / 750

const LINE3_HEIGHT = 36 * 3 * RATIO

export default {
    props: {
        content: String
    },
    data () {
        return {
            show_all: true,
            show_fold: false
        }
    },
    mounted () {
        this.checkHeight()
    },
    methods: {
        checkHeight () {
            const height = document.querySelector('.content').offsetHeight
            console.log('height', height, LINE3_HEIGHT)
            this.show_all = LINE3_HEIGHT >= height
            this.show_fold = !this.show_all
            console.log(this.show_all, this.show_fold)
        },
        fold () {
            this.show_all = !this.show_all
        }
    }
}
